import { comics } from "@/mocks/comics";

export default function Spotlight() {
  const featured = [comics[0], comics[4]];
  const points = [
    "软萌画风细腻治愈",
    "温馨剧情笑中带暖",
    "可爱角色陪伴感强",
  ];

  return (
    <section
      id="spotlight"
      className="overflow-hidden bg-secondary-100/50 py-16 md:py-20"
    >
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-bold uppercase tracking-widest text-primary-600">
            作品亮点
          </span>
          <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">
            本期重点推介
          </h2>
          <p className="mt-3 text-foreground-700">
            每期挑两部人气佳作，从画风到剧情细细拆解，看看为什么它们值得一看。
          </p>
        </div>

        <div className="mt-10 flex flex-col gap-8">
          {featured.map((comic, index) => (
            <article
              key={comic.id}
              className="flex flex-col overflow-hidden rounded-2xl bg-background-50 ring-1 ring-background-200 lg:flex-row"
            >
              <div
                className={`relative lg:w-1/2 ${
                  index % 2 === 1 ? "lg:order-2" : ""
                }`}
              >
                <div className="aspect-[4/3] h-full w-full lg:aspect-auto">
                  <img
                    src={comic.cover}
                    alt={`${comic.title}作品亮点详情插画`}
                    className="h-full w-full object-cover"
                  />
                </div>
              </div>
              <div className="flex flex-1 flex-col justify-center p-6 md:p-10">
                <div className="flex items-center gap-2">
                  <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-bold text-accent-800">
                    {comic.category}
                  </span>
                  <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-bold text-secondary-900">
                    评分 {comic.rating}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-2xl text-foreground-950 md:text-3xl">
                  {comic.title}
                </h3>
                <p className="mt-4 text-foreground-700">{comic.highlight}</p>
                <p className="mt-3 leading-relaxed text-foreground-600">
                  {comic.intro}
                </p>
                <ul className="mt-5 space-y-2">
                  {points.map((point) => (
                    <li
                      key={point}
                      className="flex items-center gap-2 text-sm text-foreground-700"
                    >
                      <span className="flex h-5 w-5 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                        <i className="ri-check-line text-xs"></i>
                      </span>
                      {point}
                    </li>
                  ))}
                </ul>
                <a
                  href="#featured"
                  className="mt-6 inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
                >
                  去同类作品逛逛
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}